var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.73684 0C5.1579 0 2.87368 1.4 1.69474 3.53684L0 1.84211V6.63158H4.78947L2.72632 4.56842C3.68421 2.72632 5.52632 1.47368 7.73684 1.47368C10.7579 1.47368 13.2632 3.97895 13.2632 7C13.2632 10.0211 10.7579 12.5263 7.73684 12.5263C5.30526 12.5263 3.31579 10.9789 2.50526 8.8421H0.957895C1.76842 11.7895 4.49474 14 7.73684 14C11.6421 14 14.7368 10.8316 14.7368 7C14.7368 3.16842 11.5684 0 7.73684 0ZM6.63158 3.68421V7.44211L10.0947 9.50526L10.6842 8.54737L7.73684 6.77895V3.68421H6.63158Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/History.dd8f3766.svg";
export { ForwardRef as ReactComponent };